export default __webpack_public_path__ + "static/media/thirdfort.67b00f1b.png";